import React from 'react';
import {COLORS, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import {EmbedWrapper} from 'app/components/tv/preview/SharedPreviewStyles';
import styled from 'styled-components';
import {getTeaserIcon} from 'app/components/tv/helpers/getTeaserIcon';

const DEFAULT_FONT_SIZE = SIZES['12'];

const Overlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${SIZES['8']};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: radial-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
`;

const EmbedHeader = styled.div`
  display: flex;
  align-items: center;
`;

const TeaserStatus = styled.div<{updated: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SIZES['34']};
  height: ${SIZES['34']};
  min-width: ${SIZES['34']};
  padding: ${SIZES['3']};
  margin-right: ${SIZES['8']};
  background: ${props => (props.updated ? "no-repeat center/100% url('/VideoTeaserGradient.svg')" : 'none')};
`;

const TeaserTitle = styled(Typography)`
  font-size: ${DEFAULT_FONT_SIZE};
  font-weight: bold;
  text-transform: uppercase;
`;

const EmbedCaptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledCaption = styled(Typography)`
  font-size: ${DEFAULT_FONT_SIZE};
  display: inline-flex;
  color: ${COLORS.white};
`;

type ImageSrc = {
  path: string;
  description: string | null;
  source: string | null;
  svg: boolean;
};

interface VideoPreviewProps {
  thumbnail: ImageSrc;
  updated: boolean;
  source: string;
  title: string;
  caption: string;
}

const VideoPreview = ({thumbnail, updated, source, title, caption}: VideoPreviewProps) => {
  const icon = getTeaserIcon(source);
  return (
    <EmbedWrapper>
      <Image entity='video' src={thumbnail} width={192} height={128} ratio='3:2' />
      <Overlay>
        <EmbedHeader>
          <TeaserStatus updated={updated}>{icon}</TeaserStatus>
          <TeaserTitle variant='title1'>{title}</TeaserTitle>
        </EmbedHeader>
        <EmbedCaptions>
          <StyledCaption variant='caption1'>{caption}</StyledCaption>
        </EmbedCaptions>
      </Overlay>
    </EmbedWrapper>
  );
};

export default VideoPreview;
